var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Bj-tabs" },
    [
      _c(
        "el-tabs",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.options.length > 1,
              expression: "options.length > 1",
            },
          ],
          attrs: { "before-leave": _vm.beforeLeave, type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.id,
            callback: function ($$v) {
              _vm.id = $$v
            },
            expression: "id",
          },
        },
        _vm._l(_vm.options, function (item, index) {
          return _c("el-tab-pane", {
            key: index,
            attrs: { label: _vm.$t(item.label), name: item.name || item.value },
          })
        }),
        1
      ),
      _vm.optionList.length === 1 ? _c("el-tabs") : _vm._e(),
      _c("div", { staticClass: "right" }, [_vm._t("default")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }